import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Template from "./Template";
import { fetchTemplate } from "../../../store/tournament/actions";
import PermissionDenied from "../../denied/PermissionDenied";

class TemplateContainer extends Component {
  render() {
    const { permission } = this.props;
    if (!permission) {
      return <PermissionDenied />;
    }
    return <Template {...this.props} />;
  }
}

const mapStateProps = state => ({
  user: state.user.info,
  template: state.tournamentState.template,
  isFetching: state.tournamentState.isFetching
});

const mapDispatchToProps = {
  fetchTemplate
};

export default connect(
  mapStateProps,
  mapDispatchToProps
)(withRouter(TemplateContainer));
